/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { useConfigService } from '@thd-nucleus/experience-context';
import { formatDistance } from '../helpers/pod-fulfillment-utils';

export const PodMessage = ({
  messageIcon,
  messageType = 'Pickup',
  isStoreNameAtEnd,
  children,
  isNewFulfillmentPodMessagingEnabled,
  nearbyStore,
  distance
}) => {

  const enablePLPFasterDeliveryOption = !!useConfigService('fs:enablePLPFasterDeliveryOption');

  const displayMilesForPickup = () => (
    (isNewFulfillmentPodMessagingEnabled && nearbyStore && distance)
    && (
      <span className="sui-text-primary">{` (${formatDistance(distance)} mi)`}
      </span>
    )
  );

  const getLineClampNumber = (message) => {
    switch (message) {
    case 'Pickup Nearby':
    case 'Limited Stock Nearby':
    case 'In-Store Clearance':
    case 'At Your Store':
      return 2;
    case 'Pickup':
    case 'Limited Stock':
    case 'Ship to Store':
      return 1;
    default:
      return 'none';
    }
  };

  if (enablePLPFasterDeliveryOption) {
    const lineClamp = getLineClampNumber(messageType);
    return (
      <div
        data-testid="pod-message"
        data-component={`podMessage${messageType}`}
        className={`sui-flex ${messageType === 'Delivery' || messageType === 'Faster Delivery' ? 'sui-mt-[2px]' : ''}`}
      >
        <div className="sui-pr-2 sui-mt-[6px]">{messageIcon}</div>
        <Typography variant="body-sm" lineClamp={lineClamp}>
          <div className="sui-pt-1">
            <span className="sui-font-bold">{`${messageType}: `}</span>
            <span className={`sui-text-sm ${isStoreNameAtEnd && lineClamp === 1 ? 'sui-break-all' : ''}`}>
              {children}
            </span>
          </div>
        </Typography>
      </div>
    );
  }

  return (
    <div
      data-testid="pod-message"
      data-component={`podMessage${messageType}`}
      className={`sui-flex ${messageType === 'Delivery' ? 'sui-mt-2' : ''}`}
    >
      <div className="sui-mt-2 sui-pr-2">{messageIcon}</div>
      <Typography variant="body-sm">
        <div className="sui-pt-1">
          <span className="sui-font-bold">{messageType}</span>
          {displayMilesForPickup()}
          <div className={`sui-text-sm ${isStoreNameAtEnd ? 'sui-line-clamp-1 sui-break-all' : ''}`}>
            {children}
          </div>
        </div>
      </Typography>
    </div>
  );
};

PodMessage.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  messageIcon: PropTypes.any.isRequired,
  messageType: PropTypes.string,
  isStoreNameAtEnd: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  isNewFulfillmentPodMessagingEnabled: PropTypes.bool,
  nearbyStore: PropTypes.shape({
    storeName: PropTypes.string,
    distance: PropTypes.number,
  }),
  distance: PropTypes.number
};

PodMessage.defaultProps = {
  messageType: 'Pickup',
  children: null,
  isStoreNameAtEnd: false,
  isNewFulfillmentPodMessagingEnabled: false,
  nearbyStore: null,
  distance: 0,
};
